import { isCodeVerificationSignup, isExistingUser } from '../app/verificationTypeSelectors';
import { Data } from '../signup-data/DATA';
export const addRequiredVerificationData = state => {
  // eslint-disable-next-line no-nested-ternary
  return isExistingUser(state) ? [] : isCodeVerificationSignup(state) ? [Data.CodeVerification] : [Data.Token];
};